module.exports = __webpack_public_path__ + "img/2.8ebb8d99.png";